/** @jsx jsx */
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import React, { Fragment } from 'react'
import { message } from 'antd'
import useRootStore from '@store/useRootStore'
import { useOnMount } from '@utils/reactExt'
import { BET_MONEY_TYPE } from 'adv-protocol/src/GameCommon'
import { appScrollTo, makeAdventurerUrl, textCopyToClipboard } from '@utils/utils'
import { HASH_PARAMETER } from '@constants/index'
// img
import FriendsInvitationBg from '@assets/images/bg/friends-invitation-bg.png'
import { ArrowIco } from '@shared/Icon/ArrowIcon'
// css
import { isMobile } from 'react-device-detect'
import { TitleWrap } from '@styles/base.style'
import { BackBtn, Button } from '@styles/button.style'
import { FriendsInvitationWrap } from './index.style'
import FriendsInvitationTab from './FriendsInvitationTab'

const FriendsInvitation: React.FC = () => {
  const { routerStore, componentStore, authStore, globalStore, logStore } = useRootStore()
  const { friendInvitationInvitor } = componentStore
  const { userInfo } = authStore

  const isFriendInvitationEnabled = globalStore.getFriendInvitationEnabled()
  if (!isFriendInvitationEnabled || !componentStore.isPossibleInvitor) {
    routerStore.push('/')
    return <Fragment/>
  }

  const makeFriendInvitationUrl = () => {
    return `${makeAdventurerUrl()}?${HASH_PARAMETER.FRIEND_NICK_NAME.KEY}=${userInfo.nick}`
  }

  const onClickCopyMyFriendNicknameUrl = async () => {
    logStore.writeButtonLog({ pageId: 'e020', buttonId: '002' }).catch(console.error)
    const url = makeFriendInvitationUrl()
    try {
      await textCopyToClipboard(url)
    } catch (err) {
      alert(err)
      console.error(err)
    }
    message.info('클립보드에 복사되었습니다.')
  }

  useOnMount(() => {
    componentStore.fetchFriendInvitationInvitor(new Date(), BET_MONEY_TYPE.G_MONEY)

    if (isMobile) {
      setTimeout(() => {
        appScrollTo(1)
      }, 0)
    }
  })

  return (
    <Fragment>
      {isMobile && (
        <TitleWrap style={{ margin: 0 }} className="title-wrap no-bg modal">
          <BackBtn onClick={() => {
            logStore.writeButtonLog({ pageId: 'e020', buttonId: '001' }).catch(console.error)
            routerStore.goBack()
          }}>
            <ArrowIco/>
          </BackBtn>
        </TitleWrap>
      )}

      <FriendsInvitationWrap>
        <div className="top-section">
          <img src={FriendsInvitationBg} alt="친구가 승부예측하면 매월 게임머니가 쏟아진다!" className="invitation-bg"/>
          <p className="txt">친구에게<span className="my-url">내 초대URL</span>을 공유해보세요</p>
          <Button className="my-url-btn" onClick={onClickCopyMyFriendNicknameUrl}>내 초대URL 복사하기</Button>
          <div className="my-friends">초대한 친구<span className="num">{friendInvitationInvitor?.invitedUserCount}</span></div>
        </div>

        <FriendsInvitationTab/>
      </FriendsInvitationWrap>

    </Fragment>
  )
}

export default observer(FriendsInvitation)
